module.exports = __webpack_public_path__ + "static/media/unilever-card-4.109b7aba.png";